import { useQuery } from '@apollo/client';
import TRIAL_END_QUERY from './TrialEndQuery.graphql.ts';

const useTrialEndQuery = () => {
  const { loading, data } = useQuery(TRIAL_END_QUERY);
  const trialEnd = data?.viewer?.billing?.subscription?.trialEnd;

  return { loading, trialEnd };
};

export default useTrialEndQuery;
